import { Head, Link } from "@inertiajs/react"
import { ArrowLeft } from "lucide-react"
import { useTranslation } from "react-i18next"

import { MasterclassForm } from "@/components/masterclasses/masterclass-form"
import AppLayout from "@/layouts/app-layout"
import { masterclassesPath } from "@/routes"
import type { MasterclassFormProps } from "@/types/masterclasses"

/**
 * OKS-54 — `Brand/Masterclasses/New`.
 *
 * Page chrome (breadcrumb + title) + the shared `<MasterclassForm>`
 * body. Form owns submit/validation/state preview.
 */
export default function MasterclassesNew({
  masterclass,
}: MasterclassFormProps) {
  const { t } = useTranslation()

  return (
    <AppLayout>
      <Head title={t("masterclasses.form.new_title")} />
      <div
        className="mx-auto flex w-full max-w-5xl flex-col gap-6 p-6"
        data-testid="masterclass-new-page"
      >
        <header className="flex flex-col gap-3">
          <Link
            href={masterclassesPath()}
            className="text-muted-foreground hover:text-foreground inline-flex w-fit items-center gap-1 text-sm"
            data-testid="masterclass-new-back-link"
          >
            <ArrowLeft className="size-4" aria-hidden="true" />
            {t("masterclasses.form.breadcrumb_root")}
          </Link>
          <h1 className="text-foreground text-2xl font-semibold tracking-tight">
            {t("masterclasses.form.new_title")}
          </h1>
        </header>

        <MasterclassForm masterclass={masterclass} mode="new" />
      </div>
    </AppLayout>
  )
}
